module.exports = __webpack_public_path__ + "static/media/iternal_logo_symbol.f3c146ed.svg";